module.exports = __webpack_public_path__ + "media/images/result_sets/circles/9n8r3r6r-b84b3c24487bfc08616915e9151fcf9a.svg";